import apiUrl from "../../../constants";
import axios from "axios";
import CryptoJS from "crypto-js";
import VueElementLoading from "vue-element-loading";
import Paginate from "vuejs-paginate";
import download from "downloadjs";
import moment from "moment";

// HUB-8193: FM/LM Mapping Master — global CSV upload, search, toggle, and audit.
// HUB-8288: five-column template incl. Is Active; one LM may map to multiple FMs.
// Header row for the sample .csv must stay in sync with the backend parser.
const FM_LM_MAPPING_COLUMNS = [
  { key: "lm_hub", header: "LM Hub", required: true },
  { key: "lm_hub_id", header: "LM Hub Id", required: true },
  { key: "fm_parent_hub", header: "FM Parent Hub", required: true },
  { key: "fm_parent_hub_id", header: "FM Parent Hub Id", required: true },
  { key: "is_active", header: "Is Active", required: true },
];

const DOWNLOAD_PAGE_LIMIT = 500;

export default {
  name: "LmParentMapping",
  components: {
    VueElementLoading,
    Paginate,
    download,
  },
  data: function () {
    return {
      createdBy: "",
      isLoadingUpload: false,
      failed: [],
      selectedFile: null,
      currentTab: "upload",
      tabs: [
        { key: "upload", value: "FM/LM Mapping Upload" },
        { key: "history", value: "History" },
      ],
      mappingColumns: FM_LM_MAPPING_COLUMNS,
      lastUploadSummary: null,

      isSearching: false,
      isLoadingDownload: false,
      mappings: [],
      pageno: 0,
      limit: 10,
      totalRows: 0,
      pageCount: 0,

      isLoadingHistory: false,
      historyRows: [],
      historyPageno: 0,
      historyLimit: 10,
      historyTotalRows: 0,
      historyPageCount: 0,

      isEditModalShow: false,
      isSavingEdit: false,
      editForm: {
        id: null,
        lmHubName: "",
        lmHubId: "",
        fmParentHubName: "",
        fmParentHubId: "",
        isActive: true,
      },
      editOriginalIsActive: true,
    };
  },

  filters: {
    moment(date) {
      if (!date) return "--";
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
  },

  mounted() {
    var userdetailEncrypt = window.localStorage.getItem("userdetail");
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdBy = userdetail[0].email;
    this.searchMappings();
  },

  methods: {
    secondFunction(tab) {
      this.currentTab = tab.key;
      if (tab.key === "history") {
        this.historyPageno = 0;
        this.getAuditHistory();
        this.lastUploadSummary = null;
      }
    },

    searchMappings() {
      this.isSearching = true;
      const params = {
        limit: this.limit,
        offset: this.pageno * this.limit,
      };

      axios
        .get(apiUrl.api_url_hubops + "fmlmmappingmaster/search", {
          params,
          headers: { Authorization: "authkey xB84JJ89Hd25" },
        })
        .then(
          (res) => {
            this.isSearching = false;
            if (res.data.ResultCode == 100) {
              this.mappings = res.data.ResponseData || [];
              const pg = res.data.pagination || {};
              this.totalRows = pg.totalCount || this.mappings.length;
              this.pageCount = pg.totalPages || 0;
            } else if (res.data.ResultCode == 101) {
              this.mappings = [];
              this.totalRows = 0;
              this.pageCount = 0;
            } else {
              this.$alertify.error(res.data.ReturnMessage);
            }
          },
          (err) => {
            console.error(err);
            this.isSearching = false;
            this.$alertify.error("Error Occured");
          },
        );
    },

    getPaginationData(pageNum) {
      this.pageno = pageNum - 1;
      this.searchMappings();
    },

    getAuditHistory() {
      this.isLoadingHistory = true;
      const params = {
        limit: this.historyLimit,
        offset: this.historyPageno * this.historyLimit,
      };

      axios
        .get(apiUrl.api_url_hubops + "fmlmmappingmaster/auditHistory", {
          params,
          headers: { Authorization: "authkey xB84JJ89Hd25" },
        })
        .then(
          (res) => {
            this.isLoadingHistory = false;
            if (res.data.ResultCode == 100) {
              this.historyRows = res.data.ResponseData || [];
              const pg = res.data.pagination || {};
              this.historyTotalRows = pg.totalCount || this.historyRows.length;
              this.historyPageCount = pg.totalPages || 0;
            } else if (res.data.ResultCode == 101) {
              this.historyRows = [];
              this.historyTotalRows = 0;
              this.historyPageCount = 0;
            } else {
              this.$alertify.error(res.data.ReturnMessage);
            }
          },
          (err) => {
            console.error(err);
            this.isLoadingHistory = false;
            this.$alertify.error("Error Occured");
          },
        );
    },

    getHistoryPagination(pageNum) {
      this.historyPageno = pageNum - 1;
      this.getAuditHistory();
    },

    auditActionBadgeClass(action) {
      const key = (action || "").toLowerCase();
      if (key === "uploaded") return "action-badge action-uploaded";
      if (key === "activated") return "action-badge action-activated";
      if (key === "deactivated") return "action-badge action-deactivated";
      return "action-badge";
    },

    openEditRow(row) {
      const isActive = row.isActive !== undefined ? !!row.isActive : !!row.is_active;
      this.editForm = {
        id: row.id,
        lmHubName: row.lmHubName || row.lm_hub_name || "",
        lmHubId: row.lmHubId || row.lm_hub_id || "",
        fmParentHubName: row.fmParentHubName || row.fm_parent_hub_name || "",
        fmParentHubId: row.fmParentHubId || row.fm_parent_hub_id || "",
        isActive,
      };
      this.editOriginalIsActive = isActive;
      this.isEditModalShow = true;
    },

    closeEditModal() {
      this.isEditModalShow = false;
      this.editForm = {
        id: null,
        lmHubName: "",
        lmHubId: "",
        fmParentHubName: "",
        fmParentHubId: "",
        isActive: true,
      };
      this.editOriginalIsActive = true;
    },

    submitEdit() {
      if (!this.editForm.id) {
        this.$alertify.error("Missing row id for edit.");
        return;
      }

      if (this.editForm.isActive === this.editOriginalIsActive) {
        this.$alertify.error("No changes to update.");
        return;
      }

      this.isSavingEdit = true;
      const payload = {
        id: Number(this.editForm.id),
        isActive: !!this.editForm.isActive,
        modifiedBy: this.createdBy,
      };

      axios
        .post(apiUrl.api_url_hubops + "fmlmmappingmaster/toggle", payload, {
          headers: { Authorization: "authkey xB84JJ89Hd25" },
        })
        .then(
          (res) => {
            this.isSavingEdit = false;
            if (res.data.ResultCode == 100) {
              this.$alertify.success(res.data.ReturnMessage || "Mapping updated.");
              this.closeEditModal();
              this.searchMappings();
            } else {
              this.$alertify.error(res.data.ReturnMessage);
            }
          },
          (err) => {
            console.error(err);
            this.isSavingEdit = false;
            this.$alertify.error("Error Occured");
          },
        );
    },

    fetchAllMappings({ isActive } = {}) {
      const allRows = [];
      let offset = 0;
      let totalCount = null;

      const fetchPage = () =>
        axios
          .get(apiUrl.api_url_hubops + "fmlmmappingmaster/search", {
            params: Object.assign(
              {
                limit: DOWNLOAD_PAGE_LIMIT,
                offset,
              },
              isActive !== undefined ? { isActive } : {},
            ),
            headers: { Authorization: "authkey xB84JJ89Hd25" },
          })
          .then((res) => {
            if (res.data.ResultCode === 101) {
              return allRows;
            }
            if (res.data.ResultCode !== 100) {
              return Promise.reject(
                new Error(
                  res.data.ReturnMessage || "Failed to fetch FM/LM mappings.",
                ),
              );
            }

            const rows = res.data.ResponseData || [];
            allRows.push.apply(allRows, rows);

            const pagination = res.data.pagination || {};
            totalCount =
              pagination.totalCount != null
                ? pagination.totalCount
                : allRows.length;

            offset += DOWNLOAD_PAGE_LIMIT;
            if (allRows.length < totalCount && rows.length > 0) {
              return fetchPage();
            }
            return allRows;
          });

      return fetchPage();
    },

    mapMappingRowToCsv(row) {
      const isActive = row.isActive !== undefined ? !!row.isActive : !!row.is_active;
      return {
        lm_hub: row.lmHubName || row.lm_hub_name || "",
        lm_hub_id: row.lmHubId || row.lm_hub_id || "",
        fm_parent_hub: row.fmParentHubName || row.fm_parent_hub_name || "",
        fm_parent_hub_id: row.fmParentHubId || row.fm_parent_hub_id || "",
        is_active: isActive ? "true" : "false",
      };
    },

    downloadMappingsFromDB() {
      this.isLoadingDownload = true;

      this.fetchAllMappings({ isActive: true })
        .then((rows) => {
          this.isLoadingDownload = false;

          if (!rows.length) {
            this.$alertify.error("No active FM/LM mappings found to download.");
            return;
          }

          const csvFields = this.mappingColumns.reduce((acc, col) => {
            acc[col.key] = col.header;
            return acc;
          }, {});

          const exportData = rows.map((row) => this.mapMappingRowToCsv(row));
          this.jsonToCSV("fm_lm_mappings.csv", exportData, csvFields);
          this.$alertify.success("Success");
        })
        .catch((err) => {
          console.error(err);
          this.isLoadingDownload = false;
          this.$alertify.error(
            (err && err.message) || "Error downloading FM/LM mappings.",
          );
        });
    },

    downloadSampleCsv() {
      const csvFields = this.mappingColumns.reduce((acc, c) => {
        acc[c.key] = c.header;
        return acc;
      }, {});
      const sampleData = [
        {
          lm_hub: "Mumbai LM",
          lm_hub_id: 1234,
          fm_parent_hub: "Mumbai FM A",
          fm_parent_hub_id: 5678,
          is_active: "true",
        },
        {
          lm_hub: "Mumbai LM",
          lm_hub_id: 1234,
          fm_parent_hub: "Mumbai FM B",
          fm_parent_hub_id: 5679,
          is_active: "false",
        },
        {
          lm_hub: "Delhi LM",
          lm_hub_id: 2345,
          fm_parent_hub: "Delhi FM",
          fm_parent_hub_id: 6789,
          is_active: "true",
        },
      ];
      this.jsonToCSV("fm_lm_mapping_sample.csv", sampleData, csvFields);
    },

    uploadConfigFile(event) {
      this.failed = [];
      this.lastUploadSummary = null;
      this.selectedFile = event.target[0].elements[0].files[0];

      if (!this.selectedFile) {
        this.$alertify.error("Please select a file to upload.");
        return false;
      }

      if (this.selectedFile.size > 5242880) {
        this.$alertify.error(
          "Failed! Upload Max File Size Should Not Be Greater Than 5 MB",
        );
        return false;
      }

      if (
        !/\.(csv)$/i.test(this.selectedFile.name) &&
        !/\.(zip)$/i.test(this.selectedFile.name)
      ) {
        this.isLoadingUpload = false;
        this.$alertify.error(
          "Failed! Please Upload Only Valid Format: .csv or .zip",
        );
        return false;
      }

      this.isLoadingUpload = true;

      const fd = new FormData();
      fd.append("uploadedBy", this.createdBy);
      fd.append("fileData", this.selectedFile);
      fd.append("fileName", this.selectedFile.name);

      axios
        .post(apiUrl.api_url_hubops + "fmlmmappingmaster/upload", fd, {
          headers: {
            Authorization: "authkey xB84JJ89Hd25",
          },
        })
        .then(
          (result) => {
            if (result.data.ResultCode == 100) {
              const data = result.data.ResponseData || {};
              this.lastUploadSummary = {
                totalRows: data.totalRows != null ? data.totalRows : null,
                validCount: data.validCount != null ? data.validCount : null,
                insertedCount:
                  data.insertedCount != null ? data.insertedCount : null,
                updatedCount:
                  data.updatedCount != null ? data.updatedCount : null,
              };

              const parts = [];
              if (this.lastUploadSummary.insertedCount != null) {
                parts.push(
                  `${this.lastUploadSummary.insertedCount} new mappings inserted`,
                );
              }
              if (this.lastUploadSummary.updatedCount != null) {
                parts.push(
                  `${this.lastUploadSummary.updatedCount} existing mappings updated`,
                );
              }
              const toast = parts.length
                ? `Upload complete: ${parts.join(", ")}.`
                : result.data.ReturnMessage || "Upload complete.";
              this.$alertify.success(toast);
              this.resetForm(null, true);
              this.pageno = 0;
              this.searchMappings();
            } else {
              this.$alertify.error(result.data.ReturnMessage);
            }

            if (
              result &&
              result.data.failed &&
              result.data.failed.length > 0
            ) {
              this.failed = result.data.failed;
            }

            this.isLoadingUpload = false;
          },
          (error) => {
            console.error(error);
            this.isLoadingUpload = false;
            this.$alertify.error("Error Occured");
          },
        );
    },

    onUploadSubmit: function () {
      this.$validator
        .validateAll()
        .then((result) => {
          if (result) {
            this.uploadConfigFile(event);
            event.target.reset();
          }
        })
        .catch(() => {
          this.$alertify.error("Error Occured");
        });
    },

    exportFailedConfig() {
      if (!this.failed || this.failed.length === 0) {
        this.$alertify.error("No failed rows to export.");
        return;
      }
      this.isLoadingUpload = true;

      const csvFields = this.mappingColumns.reduce((acc, c) => {
        acc[c.header] = c.header;
        return acc;
      }, {});
      csvFields.Reason = "Reason";

      this.jsonToCSV("fm_lm_mapping_failed.csv", this.failed, csvFields);
      this.isLoadingUpload = false;
    },

    jsonToCSV(filename, data, csvfield, skipFilter = []) {
      let csvData = "";
      const fieldKeys = Object.keys(csvfield).filter(
        (key) => skipFilter.indexOf(key) === -1,
      );
      csvData += fieldKeys.map((key) => csvfield[key]).join(",") + "\r\n";
      data.forEach(function (item) {
        csvData += fieldKeys
          .map((key) => {
            let value = item[key];
            if (value === null || value === undefined) return "";
            let escapedCSV = value + "";
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"';
            }
            if (escapedCSV == "null") return "";
            return escapedCSV;
          })
          .join(",");
        csvData += "\r\n";
      });
      return this.export(csvData, filename, "application/csv");
    },

    export(data, filename, mime) {
      const blob = this.base64ToBlob(data, mime);
      download(blob, filename, mime);
    },

    base64ToBlob(data, mime) {
      const base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      const bstr = atob(base64);
      let n = bstr.length;
      const u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    resetForm(event, preserveSummary = false) {
      this.isLoadingUpload = false;
      this.failed = [];
      this.selectedFile = null;
      if (!preserveSummary) this.lastUploadSummary = null;
      this.$validator.reset();
      this.errors.clear();
      if (event && event.target && event.target.form) {
        event.target.form.reset();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/LmParentMapping/LmParentMapping.js